import { z } from "zod";

export const SaidaProdutoSchema = z.object({
  id_saida_produto: z.coerce.number().int().optional(),
  data: z.coerce.date().nullable().optional(),
  dataSaida: z.coerce.date().nullable().optional(),
  id_centro_custo: z.coerce.number().int().nullable().optional(),
  id_centro_custo_destino: z.coerce.number().int().nullable().optional(),
  id_produto_servico: z.coerce.number().int().nullable().optional(),
  nro_nota_fiscal: z.coerce.string().max(250).nullable().optional(),
  quantidade: z.coerce.number().nullable().optional(),
  id_fornecedor: z.coerce.number().int().nullable().optional(),
  id_funcionario: z.coerce.number().int().nullable().optional(),
  nr_nota_fiscal: z.coerce.string().max(250).nullable().optional(),
  id_sessao_multipla: z.coerce.string().uuid().nullable().optional(),
  valor_unitario: z.coerce.number().min(0).nullable().optional(),
  valor_total: z.coerce.number().min(0).nullable().optional(),
  ultimoValorUnitario: z.coerce.number().min(0).nullable().optional(),
  localAplicacao: z.coerce.string().nullable().optional(),
  unidade: z.coerce.string().nullable().optional(),

});

export type SaidaProdutoForm = z.infer<typeof SaidaProdutoSchema>;